import { render, staticRenderFns } from "./WarningColorRectIcon.vue?vue&type=template&id=0334fb0a&"
import script from "./WarningColorRectIcon.vue?vue&type=script&lang=js&"
export * from "./WarningColorRectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports